module.exports = __webpack_public_path__ + "img/slim24.884df967.jpg";